import Vue from 'vue'

// 全局过滤器
import * as filters from './filters.js'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import * as globals from './global.js'
Object.keys(globals).forEach(key => {
  Vue.prototype[key] = globals[key]
})



// WEBPACK FOOTER //
// ./src/filters/index.js